import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, Animated } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import colors from "../theme/colors";

const PhraseCard = ({ phrase, onIdealPress }) => {
  const scaleAnim = React.useRef(new Animated.Value(1)).current;

  const handleIdealPress = () => {
    // Animate button press
    Animated.sequence([
      Animated.timing(scaleAnim, {
        toValue: 0.95,
        duration: 100,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnim, {
        toValue: 1,
        duration: 100,
        useNativeDriver: true,
      }),
    ]).start();

    // Call the parent handler
    onIdealPress(phrase);
  };

  return (
    <View style={styles.phraseCard}>
      <View style={styles.phraseContent}>
        <View style={styles.phraseTextContainer}>
          <View style={styles.phraseHeader}>
            <Text style={styles.phraseCategory}>{phrase.category}</Text>
          </View>
          <Text style={styles.phraseArabic}>{phrase.arabic}</Text>
          <Text style={styles.phraseTransliteration}>{phrase.transliteration}</Text>
          <Text style={styles.phraseTranslation}>{phrase.translation}</Text>
        </View>
        <TouchableOpacity style={styles.idealButton} onPress={handleIdealPress} activeOpacity={0.8}>
          <Animated.View style={{ transform: [{ scale: scaleAnim }] }}>
            <Ionicons name="bulb" size={24} color={colors.white} />
          </Animated.View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  phraseCard: {
    backgroundColor: colors.white,
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: colors.lightGray,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  phraseContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  phraseTextContainer: {
    flex: 1,
    marginRight: 12,
  },
  phraseHeader: {
    marginBottom: 8,
  },
  phraseCategory: {
    fontSize: 10,
    color: colors.primary,
    fontFamily: "KhebratMusamim",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  phraseArabic: {
    fontSize: 18,
    fontWeight: "bold",
    color: colors.text.primary,
    marginBottom: 4,
    fontFamily: "KhebratMusamim",
    textAlign: "left",
  },
  phraseTransliteration: {
    fontSize: 14,
    color: colors.primary,
    marginBottom: 2,
    fontFamily: "KhebratMusamim",
  },
  phraseTranslation: {
    fontSize: 12,
    color: colors.gray,
    fontFamily: "KhebratMusamim",
  },
  idealButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: colors.primary,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
});

export default PhraseCard;
